import { render } from "./CompanyReviewsEditor.vue?vue&type=template&id=c279d2e4"
import script from "./CompanyReviewsEditor.vue?vue&type=script&lang=js"
export * from "./CompanyReviewsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__